/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
import "./earnRewardItem.scss";
import RewardIcon from "../assets/invite-reward.svg";

interface ItemProp {
  inviterNum?: number;
  inviterTxt?: string;
  currency?: string;
  awardTxt?: string;
  activityData?: any;
}

interface RewardItemProp {
  num: number;
  desc: string;
  showLine?: boolean;
}

export function YourRewardItem({ num, desc, showLine = true }: RewardItemProp) {
  return (
    <div className="reward_item">
      <div className="reward_num">{num}</div>
      <div className="reward_desc">{desc}</div>
      {showLine && <div className="reward_line" />}
    </div>
  );
}

export function EarnRewardLeftItem({ inviterNum, inviterTxt, currency, awardTxt }: ItemProp) {
  return (
    <div className="reward_flex">
      <RewardIcon />
      <span>
        Invite {inviterNum} {inviterTxt} to register and done an order, you will receive a{" "}
        <em>
          {currency}
          {awardTxt}
        </em>{" "}
        coupon
      </span>
    </div>
  );
}

export function EarnRewardRightItem({ currency, awardTxt }: ItemProp) {
  return (
    <div className="reward_flex">
      <RewardIcon />
      <span>
        The friends you invited to register can also receive a{" "}
        <em>
          {currency}
          {awardTxt}
        </em>{" "}
        coupon
      </span>
    </div>
  );
}

export function EarnRewardStep1Item() {
  return (
    <div className="code_flex">
      <div className="title">Step 1:</div>
      <div className="content">Copy and share your code with your friends.</div>
    </div>
  );
}

export function EarnRewardStep2Item({ currency, activityData }: ItemProp) {
  return (
    <div className="code_flex">
      <div className="title">Step 2:</div>
      <div className="content">
        Your friends enter the code at search, checkout, or the coupon
        redemption page to get a{" "}
        {`${currency}${activityData?.invitedCoupon?.discount}`}{" "}
        discount.
      </div>
    </div>
  );
}

export function EarnRewardStep3Item({ currency, activityData }: ItemProp) {
  return (
    <div className="code_flex">
      <div className="title">Step 3:</div>
      <div className="content">
        You will receive an{" "}
        {`${currency}${activityData?.inviterCoupon?.discount}`}{" "}
        discount coupon when your friend completes their first order.
      </div>
    </div>
  );
}
